import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentDeleteFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v9l2-2h7ZM8.354 3.354 6.707 5l1.647 1.646-.708.708L6 5.707 4.354 7.354l-.708-.708L5.293 5 3.646 3.354l.708-.708L6 4.293l1.646-1.647.708.708Z"
    />
  </svg>
);
export default IconCommentDeleteFilledSizeXs;
